import React from 'react';
import '../../css/AgentLanding.css';

function AgentLanding() {
    return (
        <div className="agentLandingContainer">
            <div className="agentLandingFirstContainer">
                <div className="agentLandingFirstWrap">
                    <div className="agentLandingFirstTitle">
                        Realtor Developed Service Directory for Realtors
                    </div>
                    <div className="agentLandingFirstBody">
                        Access a professionally curated directory of verified service providers for your real estate business.
                    </div>
                    <div className="agentLandingFirstButton">
                        <a href="/directory">
                            <div className="blue-button">CHECK IT OUT! >></div>
                        </a>
                    </div>
                </div>
            </div>
            <div className="agentLandingSecondContainer">
                <div className="agentLandingSecondWrap">
                    <div className="agentLandingSecondTitle">
                        All the Services You Need in One Place
                    </div>
                    <div className="agentLandingSecondSubTitle">
                        Quickly search, select, and book top-tier service professionals in minutes. Save valuable time and streamline your vendor selection process.
                    </div>
                    <div className='agentLandingSecondBodyWrap'>
                        <div className="agentLandingSecondBody">
                            <div className="agentLandingSecondBodyStepWrapGroup">
                                <div className="agentLandingSecondBodyStepWrap">
                                    <div className="agentLandingSecondBodyStepImage1"/>
                                    <div className="agentLandingSecondBodyStepLabel">Select Trades</div>
                                </div>
                                <div className="agentLandingSecondBodyStepWrap">
                                    <div className="agentLandingSecondBodyStepImage2"/>
                                    <div className="agentLandingSecondBodyStepLabel">Select Cities</div>
                                </div>
                            </div>
                            <div className="agentLandingSecondBodyStepWrapGroup">
                                <div className="agentLandingSecondBodyStepWrap">
                                    <div className="agentLandingSecondBodyStepImage3"/>
                                    <div className="agentLandingSecondBodyStepLabel">Select Pros</div>
                                </div>
                                <div className="agentLandingSecondBodyStepWrap">
                                    <div className="agentLandingSecondBodyStepImage4"/>
                                    <div className="agentLandingSecondBodyStepLabel">Connect</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AgentLanding;
